import moment from "moment";

export function formatRelativeTime(unixSeconds: number): string {
  return moment.unix(unixSeconds).fromNow();
}
